var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3118 25H10.343L13.9276 14.8182H16.2045L19.794 25H17.8253L15.1058 16.9062H15.0263L12.3118 25ZM12.3764 21.0078H17.7457V22.4893H12.3764V21.0078ZM21.1351 25V14.8182H24.9533C25.7355 14.8182 26.3917 14.964 26.9221 15.2557C27.4557 15.5473 27.8584 15.9484 28.1301 16.4588C28.4052 16.9659 28.5428 17.5426 28.5428 18.1889C28.5428 18.8419 28.4052 19.4219 28.1301 19.929C27.8551 20.4361 27.449 20.8355 26.9121 21.1271C26.3752 21.4155 25.714 21.5597 24.9284 21.5597H22.3979V20.0433H24.6799C25.1373 20.0433 25.5118 19.9638 25.8034 19.8047C26.0951 19.6456 26.3105 19.4268 26.4498 19.1484C26.5923 18.87 26.6635 18.5502 26.6635 18.1889C26.6635 17.8277 26.5923 17.5095 26.4498 17.2344C26.3105 16.9593 26.0935 16.7455 25.7985 16.593C25.5068 16.4373 25.1306 16.3594 24.6699 16.3594H22.9796V25H21.1351Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/Avatar_2.f28b566ff139f5c2f55c7531ce0e87cf.svg";
export { ForwardRef as ReactComponent };